module.exports = __webpack_public_path__ + "img/poster.74d707fb.png";